import { createFileRoute } from "@tanstack/react-router";
import { AdminSupportAnalyticsPage } from "@/components/admin/pages/AdminSupportAnalyticsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/support/analytics")({
  component: AdminSupportAnalyticsPage,
});
